/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Status_ErrorInputs */

const en_admin_ai_chat_status_error = /** @type {(inputs: Admin_Ai_Chat_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No response`)
};

const de_admin_ai_chat_status_error = /** @type {(inputs: Admin_Ai_Chat_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Antwort`)
};

const es_admin_ai_chat_status_error = /** @type {(inputs: Admin_Ai_Chat_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin respuesta`)
};

const fr_admin_ai_chat_status_error = /** @type {(inputs: Admin_Ai_Chat_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de réponse`)
};

const nl_admin_ai_chat_status_error = /** @type {(inputs: Admin_Ai_Chat_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen antwoord`)
};

/** @type {(inputs: Admin_Ai_Chat_Status_ErrorInputs) => LocalizedString} */
const it_admin_ai_chat_status_error = en_admin_ai_chat_status_error;

/** @type {(inputs: Admin_Ai_Chat_Status_ErrorInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_status_error = en_admin_ai_chat_status_error;

/** @type {(inputs: Admin_Ai_Chat_Status_ErrorInputs) => LocalizedString} */
const pl_admin_ai_chat_status_error = en_admin_ai_chat_status_error;

/** @type {(inputs: Admin_Ai_Chat_Status_ErrorInputs) => LocalizedString} */
const hu_admin_ai_chat_status_error = en_admin_ai_chat_status_error;

/** @type {(inputs: Admin_Ai_Chat_Status_ErrorInputs) => LocalizedString} */
const ro_admin_ai_chat_status_error = en_admin_ai_chat_status_error;

/**
* | output |
* | --- |
* | "No response" |
*
* @param {Admin_Ai_Chat_Status_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_status_error = /** @type {((inputs?: Admin_Ai_Chat_Status_ErrorInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Status_ErrorInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_status_error(inputs)
	if (locale === "de") return de_admin_ai_chat_status_error(inputs)
	if (locale === "es") return es_admin_ai_chat_status_error(inputs)
	if (locale === "fr") return fr_admin_ai_chat_status_error(inputs)
	if (locale === "nl") return nl_admin_ai_chat_status_error(inputs)
	if (locale === "it") return it_admin_ai_chat_status_error(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_status_error(inputs)
	if (locale === "pl") return pl_admin_ai_chat_status_error(inputs)
	if (locale === "hu") return hu_admin_ai_chat_status_error(inputs)
	return ro_admin_ai_chat_status_error(inputs)
});
export { admin_ai_chat_status_error as "admin.ai_chat.status_error" }